<h1 mat-dialog-title>Tiertod melden</h1>

<div mat-dialog-content>
    <kiene-gruppe-tier-tod-melden [dialog]="true" [tier]="tier" (tierGemeldet)="dialogRef.close(tier)">
        <ng-container additional-actions>
            <button type="button" mat-button (click)="dialogRef.close()">Abbrechen</button>
        </ng-container>
    </kiene-gruppe-tier-tod-melden>
</div>
